import React from 'react';
import { Grid, Box, Typography, Card, CardContent } from "@mui/material";
import imgUrl from "../assets/images/imgUrl";
import { Bolt } from '@mui/icons-material';


const qualities = [
  {
    title: 'Non-Religious and Non-Political Movement',
    description: 'Free to follow your own religion and political alignment.',
    color: 'teal1',
  },
  {
    title: 'Believe in 7 Human Values',
    description: 'Truth, Gratitude, Forgiveness, Love, Humility, Giving, and Patience.', 
    color: 'yellow1',
  },
  {
    title: 'Justice',
    description:'Fight for causes of Justice.',
    color: 'green1',
  },
  {
    title: 'Service',
    description: 'Serve the poor, orphans, widows, elderly, sick and underprivileged.',
    color: 'yellow1',
  },
  {
    title: 'International Networking',
    description: 'Connecting I Am Peacekeeper Advocates across the globe.',
    color: 'green1',
  },
  {
    title: 'Arbitrate',
    description: 'Resolve disputes and promote Peace among people.',
    color: 'teal1',
  },
  {
    title: 'Faith',
    description: 'Do your best and trust God (the higher power) for the rest.',
    color: 'yellow1',
  },
];

const SevenMission = () => {
  return (
    <>
       {/* Home 7Mission section */}
      <Box
              className="sevenQualitiesBg commonBannerBg"
              sx={{
                backgroundSize: "cover",
                backgroundPosition: "center",
                // position: "relative",
                color: "white",
                px: 2,
              }}
              mb={5}
             
            >
              {/* Mini Header (Top-Left) */}
              
              <Box
                sx={{
                  position: "absolute",
                  top: 80,
                  left: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                    component="img"
                    src={imgUrl.doveImg}
                    alt="Peace Dove Logo"
                    sx={{ maxWidth: 200, height: 'auto', mr: 1 }}
                  />
              </Box>
             
      </Box>

      {/* 7Qualities Section Start*/}   
        
        {/* sevenQualities heading section */}
        <Box className="d-flex-align-center-justify-center" mt={5}>
          <Grid container direction="column" alignItems="center" spacing={2} className="d-flex-align-center-justify-center">
            <Grid size={12} className="d-flex-align-center-justify-center flex-direction-column">
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
              <Typography variant="h1" className="green-title mainHeading" mt={1} sx={{fontFamily: 'var(--heading-font)', fontWeight: 400, fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' }}}>
                7 Missions : I Am Peacekeeper Movement
              </Typography>
            </Grid>
            
          </Grid>
        </Box>

        {/* sevenMission main section  */}

        <Box className="qualities-container">
     
      {/* Row 1: 3 Circles */}
      <Grid container spacing={2} justifyContent="center" className="qualities-row">
        {qualities.slice(0, 3).map((item, index) => (
          <Grid key={index} size={{ xs: 12, sm: 3 }}>
            <Card className={`quality-card ${item.color}`}>
              <CardContent className='pb-16px'>
                <Typography variant="subtitle1" sx={{fontFamily: 'var(--default-font) !important', fontWeight:800}} className="quality-title">
                  {item.title}
                </Typography>
                <Typography variant="body2" className="quality-description" sx={{fontFamily: 'var(--default-font) !important', fontWeight: 400}}>
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Row 2: 3 Circles */}
      <Grid container spacing={2} justifyContent="center" className="qualities-row">
        {qualities.slice(3, 6).map((item, index) => (
          <Grid size={{ xs: 12, sm: 3 }} key={index + 3}>
            <Card className={`quality-card ${item.color}`}>
              <CardContent className='pb-16px'>
                <Typography variant="subtitle1" className="quality-title">
                  {item.title}
                </Typography>
                <Typography variant="body2" className="quality-description" sx={{fontFamily: 'var(--default-font) !important', fontWeight: 400}}>
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Row 3: 1 Circle Centered */}
      <Grid container justifyContent="center" className="qualities-row">
        <Grid size={{ xs: 12, sm: 3 }}>
          <Card className={`quality-card ${qualities[6].color}`}>
            <CardContent className='pb-16px'>
              <Typography variant="subtitle1" className="quality-title">
                {qualities[6].title}
              </Typography>
              <Typography variant="body2" className="quality-description" sx={{fontFamily: 'var(--primary-font)', fontWeight: 400}}>
                {qualities[6].description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  
   
    </>
  )
}

export default SevenMission